import { gql } from '@apollo/client';

import { threadFragment } from '../fragments';

export default gql`
  mutation DownvoteThread($courseId: String!, $threadId: String!) {
    downvoteThread(courseId: $courseId, threadId: $threadId, input: {})
      @rest(
        type: "Thread"
        path: "/courses/{args.courseId}/threads/{args.threadId}/downvote"
        method: "PUT"
      ) {
      ...Thread
    }
  }
  ${threadFragment}
`;
